import { Container, Typography, makeStyles } from '@material-ui/core';
import { PageHeader } from 'pages/CustomerBookingCreate/components/PageHeader';
import { STEP_CREATE_ACCOUNT_REQUEST_VERIFICATION, STEP_CREATE_ACCOUNT_VERIFY_MOBILE, STEP_PERSONAL_DETAILS } from 'pages/CustomerBookingCreate/constants';
import { otpMobileNumberState, stepState } from 'pages/CustomerBookingCreate/state';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { toast } from 'react-hot-toast';
import { PinInput } from 'react-input-pin-code';
import { useHistory } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { validateMobilePhoneNumber } from 'services/authentication.service';
import { HelvNeue } from 'themes/theme';
import { toasterror } from 'util/toasterror';
import { useTrackEvent } from 'util/trackEvent';

const useStyles = makeStyles((theme) => {
  return {
    messageContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      height: '100%',
      "&>*": {
        marginBottom: theme.spacing(3)
      }
    },
    pinContainer: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      height: '100%',
      padding: theme.spacing(4),
      "&>*": {
        marginBottom: theme.spacing(3)
      }
    },
    snek: {
      height: theme.spacing(20),
      width: 'auto'
    },
    large: {
      fontFamily: HelvNeue,
      fontWeight: 300
    }
  }
})


const NewPinView = ({ isInvalid = false, onNewPin = (v) => { } }) => {
  const classes = { ...useStyles() }
  const [newPinCode, setNewPinCode] = useState(new Array(4).fill(''));


  return (
    <Container className={classes.pinContainer}>
      <PinInput
        autoFocus
        values={newPinCode}
        size="lg"
        placeholder=""
        onChange={(char, index, pinString) => {
          setNewPinCode(pinString)
        }}
        onComplete={(v) => {

          setNewPinCode(new Array(4).fill(''))
          onNewPin(v.join(''))
        }} />
    </Container>
  )
}


const CreateAccountVerifyMobileScreen = ({ }) => {
  const classes = useStyles()
  const [step, setStep] = useRecoilState(stepState);
  const [otpMobileNumber, setOtpMobileNumber] = useRecoilState(otpMobileNumberState);
  const [isInvalid, setIsInvalid] = useState(false);
  const [loading, setLoading] = useState(false);
  const history = useHistory()
  const trackEvent = useTrackEvent()


  const verifyCode = useCallback(
    async (code) => {
      setLoading(true);
      try {
        await validateMobilePhoneNumber({ code, number: otpMobileNumber })
        setLoading(false);
        setStep(STEP_PERSONAL_DETAILS)
        history.replace(STEP_PERSONAL_DETAILS, {defer: true})
      } catch (error) {
        trackEvent('Create Booking Verify Mobile - error', { error: error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details || error?.message })
        toasterror(error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details || error?.message, {error})
        setLoading(false);
      }
    },
    [otpMobileNumber],
  );

  return (
    <>
      <PageHeader
        loading={loading}
        title="Verify your Mobile Number"
        subheader={`Enter the verification code we sent at ${otpMobileNumber}`}
        isCartEnabled={false}
        currentStep={STEP_CREATE_ACCOUNT_VERIFY_MOBILE}
        backStep={STEP_CREATE_ACCOUNT_REQUEST_VERIFICATION}
        showBreadcrumbs
      >
        <NewPinView isInvalid={isInvalid} onNewPin={(v) => {
          trackEvent('Create Booking Verify Mobile - input pin')
          verifyCode(v)
        }} />
      </PageHeader>
    </>
  )
}

export { CreateAccountVerifyMobileScreen }